import { toast, type ExternalToast } from 'sonner';

type HapticType = 'error' | 'success' | 'warning';

const haptic = (type: HapticType) => {
  if (typeof window === 'undefined') return;
  try {
    window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred(type);
  } catch {}
};

export const notify = {
  success: (message: string, options?: ExternalToast) => {
    haptic('success');
    return toast.success(message, options);
  },
  error: (message: string, options?: ExternalToast) => {
    haptic('error');
    return toast.error(message, { duration: 6000, ...options });
  },
  warning: (message: string, options?: ExternalToast) => {
    haptic('warning');
    return toast.warning(message, options);
  },
  info: (message: string, options?: ExternalToast) => toast.info(message, options),
  dismiss: toast.dismiss,
};

export const copyToClipboard = async (text: string, messages: { success?: string; error: string }) => {
  try {
    await navigator.clipboard.writeText(text);
    if (messages.success) notify.success(messages.success);
    return true;
  } catch {
    notify.error(messages.error);
    return false;
  }
};
